/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Typography,
  Box,
  FormHelperText,
  Divider,
} from "@mui/material";

const QuestionsPopUp = ({
  open,
  onClose,
  questionsData = [],
  onSubmit,
  title,
}) => {
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});

  const handleChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
    setErrors((prev) => ({ ...prev, [questionId]: "" }));
  };

  const handleDialogClose = () => {
    setAnswers({});
    setErrors({});
    onClose();
  };

  const handleSubmit = () => {
    const newErrors = {};

    questionsData.forEach((q) => {
      const value = answers[q.question_id];
      if (
        value === undefined ||
        value === "" ||
        (q.question_type === 2 && (isNaN(value) || value.length > 12))
      ) {
        newErrors[q.question_id] = "This field is required";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const payload = questionsData.map((q) => ({
      ...q,
      answer: answers[q.question_id],
    }));

    onSubmit(payload);
    handleDialogClose();
  };

  const handleNumberKeyDown = (e) => {
    const invalidChars = ["e", "E", "+", "-", "."];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          maxHeight: "500px",
          height: "auto",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" fontWeight={"bold"}>
          {" "}
          Adding candidate to {title}{" "}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {questionsData.map((q, idx) => (
          <Box key={q.question_id}>
            <Typography sx={{ fontWeight: 500, mb: 1 }}>
              {idx + 1}. {q.question}
            </Typography>

            {q.question_type === 3 && (
              <>
                <RadioGroup
                  value={answers[q.question_id] || ""}
                  onChange={(e) => handleChange(q.question_id, e.target.value)}
                >
                  {q.ques_ans.map((option) => (
                    <FormControlLabel
                      key={option.answer_id}
                      value={option.value}
                      control={<Radio />}
                      label={option.value}
                    />
                  ))}
                </RadioGroup>
                {errors[q.question_id] && (
                  <FormHelperText error>{errors[q.question_id]}</FormHelperText>
                )}
              </>
            )}

            {q.question_type === 1 && (
              <TextField
                placeholder="Please enter answer"
                fullWidth
                multiline
                minRows={3}
                value={answers[q.question_id] || ""}
                onChange={(e) => handleChange(q.question_id, e.target.value)}
                error={Boolean(errors[q.question_id])}
                helperText={errors[q.question_id]}
              />
            )}

            {q.question_type === 2 && (
              <TextField
                placeholder="Enter the number"
                fullWidth
                size="small"
                inputProps={{ maxLength: 12 }}
                value={answers[q.question_id] || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,12}$/.test(val)) {
                    handleChange(q.question_id, val);
                  }
                }}
                onKeyDown={handleNumberKeyDown}
                error={Boolean(errors[q.question_id])}
                helperText={errors[q.question_id]}
              />
            )}
          </Box>
        ))}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2 }}>
        <Button size="small" onClick={handleDialogClose}>Cancel</Button>
        <Button size="small" variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuestionsPopUp;
